import Immutable from "immutable";
import _ from "lodash";
import { removeFields, toJSON } from "src/services/object";
import * as GQL from "src/types/graphql";

export type IsDraft = {
  readonly isDraft: true;
};

export type Draft<ORIGINAL> = ORIGINAL & IsDraft;

export type Change<T, V = T> = {
  readonly original: T;
  readonly draft: V | undefined;
};

export type WithDraft<T> = { readonly draft: T };

export const FormTemplateId = (formTemplateId: uuid) =>
  Immutable.Record<{ formTemplateId: uuid }>({
    formTemplateId,
  })({ formTemplateId });
export type FormTemplateIdType = Immutable.Record<{ formTemplateId: uuid }>;

export const MessageTemplateId = (
  messageTemplateId: GQL.message_template_type_enum
) =>
  Immutable.Record<{ messageTemplateId: GQL.message_template_type_enum }>({
    messageTemplateId,
  })({ messageTemplateId });

export type MessageTemplateIdType = Immutable.Record<{
  messageTemplateId: uuid;
}>;

export function toOriginal<ORIGINAL>(draft: Draft<ORIGINAL>): ORIGINAL {
  return removeFields(draft, "isDraft") as ORIGINAL;
}

export function hasChanges<ORIGINAL extends {}>(
  original: ORIGINAL | undefined | null,
  draft: Draft<ORIGINAL> | undefined
): boolean {
  if (original === undefined || original === null) {
    return true;
  }

  if (draft === undefined) {
    return false;
  }

  return !_.isEqual(toJSON(original), toJSON(toOriginal(draft)));
}

export type FormTemplateMetadata = {
  id: uuid;
  name: string;
  description: string | null;
  active: boolean;
  lottery_offers_enabled: boolean;
  offer_start_at: timestamptz | null;
  locked: boolean;
  mode: GQL.form_template_mode_enum;
  form_template_rule: {
    rules: {
      status_rule: { next_form_template: { name: string } } | null;
    }[];
  } | null;
  schema_version: string;
  show_waitlist_position: boolean;
  allow_form_deletion_by_family: boolean;
};
